// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__3lJz7","deliver_box":"styles_deliver_box__11mJy","deliver_tip":"styles_deliver_tip__3txL8"};